// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchAlertBanner_root__ayT3t","content":"SearchAlertBanner_content__1JNyC","button":"SearchAlertBanner_button__NfhWM","media":"SearchAlertBanner_media__WdZTd"};